module.exports = __webpack_public_path__ + "static/media/ico-video.190cc7a0.svg";